/* __next_internal_client_entry_do_not_use__ LanguageSelectorSection auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLanguage } from "@faire/retailer-visitor-shared/hooks/retailer/useLanguage";
import { useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import React, { Suspense } from "react";
import { LazyLanguageSelector } from "../../LanguageSelector/LazyLanguageSelector";
import { HeaderLine } from "../styled";
export var LanguageSelectorSection = /*#__PURE__*/ React.memo(function() {
    var _useLanguage = useLanguage(), showLanguageSelector = _useLanguage.showLanguageSelector, showSEOLanguageSelector = _useLanguage.showSEOLanguageSelector, availableLanguageSelectorLocales = _useLanguage.availableLanguageSelectorLocales;
    var _useUserStore = useUserStore([
        "browserLevelLanguage",
        "browserLevelLocaleKey"
    ]), browserLevelLanguage = _useUserStore.browserLevelLanguage, browserLevelLocaleKey = _useUserStore.browserLevelLocaleKey;
    return showLanguageSelector || showSEOLanguageSelector ? /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Suspense, {
                fallback: null,
                children: /*#__PURE__*/ _jsx(LazyLanguageSelector, {
                    eventKey: "logged-out-top",
                    browserLanguage: browserLevelLanguage,
                    browserLocale: browserLevelLocaleKey,
                    availableLocales: availableLanguageSelectorLocales,
                    assignLocalizedUrl: true
                })
            }),
            /*#__PURE__*/ _jsx(HeaderLine, {})
        ]
    }) : null;
});
